module.exports = __webpack_public_path__ + "img/gain2-min.53889c11.png";